import { combineReducers } from "@reduxjs/toolkit";
import { reducer as appointmentFiltersReducer } from "../slices/appointmentFilters";
import { reducer as calendarReducer } from "../slices/calendar";
import { reducer as carePlanFiltersReducer } from "../slices/carePlanFilters";
import { reducer as configReducer } from "../slices/configuration";
import { reducer as encounterFiltersReducer } from "../slices/encounterFilters";
import { reducer as encountersReducer } from "../slices/encounters";
import { reducer as medicationAdministrationFiltersReducer } from "../slices/medicationAdministrationFilters";
import { reducer as optionsReducer } from "../slices/options/options";
import templatesReducer from "../slices/template";
import { reducer as triageFiltersReducer } from "../slices/triageFilters";
import { reducer as userReducer } from "../slices/user";
import { reducer as invoiceFiltersReducer } from "../slices/invoiceFilters";
import { reducer as paymentFiltersReducer } from "../slices/paymentFilters";
import { reducer as chargeItemDefinitionFiltersReducer } from "../slices/chargeItemDefinitionFilters";
import {
  billingMessagingFiltersReducer,
  communicationMessagingFiltersReducer,
} from "../slices/messagingLogFilters";

const rootReducer = combineReducers({
  calendar: calendarReducer,
  options: optionsReducer,
  user: userReducer,
  config: configReducer,
  templates: templatesReducer,
  encounters: encountersReducer,
  appointmentFilters: appointmentFiltersReducer,
  encounterFilters: encounterFiltersReducer,
  carePlanFilters: carePlanFiltersReducer,
  triageFilters: triageFiltersReducer,
  medicationAdministrationFilters: medicationAdministrationFiltersReducer,
  invoiceFilters: invoiceFiltersReducer,
  paymentFilters: paymentFiltersReducer,
  chargeItemDefinitionFilters: chargeItemDefinitionFiltersReducer,
  billingMessagingFilters: billingMessagingFiltersReducer,
  communicationMessagingFilters: communicationMessagingFiltersReducer,
});

export default rootReducer;
